import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

import { InitialValues, ValidationErrors } from 'forms/types';
import { composeValidators, isPresent, isPhone, isEmail } from 'forms/validators';

import { ApplicationFormValues } from '../form/types';

export const createValidate =
  () =>
  ({
    firstName,
    lastName,
    email,
    phoneType,
    phoneNumber,
  }: InitialValues<ApplicationFormValues>): ValidationErrors<ApplicationFormValues> => {
    const emailValidator = composeValidators(isPresent, isEmail);
    const phoneValidator = composeValidators(isPresent, isPhone);

    const errors: ValidationErrors<ApplicationFormValues> = {
      firstName: isPresent(firstName),
      lastName: isPresent(lastName),
      phoneType: isPresent(phoneType),
      email: emailValidator(email),
      phoneNumber: phoneValidator(phoneNumber),
    };

    return omitBy(errors, isNil);
  };
